import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { Customer, CustomerSearchHistory } from '~core/models';
import { CustomerService, NavigationService, StorageService } from '~core/services';

/**
 * This component is responsible for basic searching of customers.
 */
@UntilDestroy()
@Component({
  selector: 'app-basic-search',
  templateUrl: 'basic-search.component.html',
})

export class BasicSearchComponent implements OnInit, OnDestroy {
  public form: UntypedFormGroup;
  public selectedClub: any;
  public previousInput: any = '';
  public searchInput: any = new Subject<string>();
  public customers: Array<Customer> = [];
  public searchHistory: Array<CustomerSearchHistory>;

  public recentSearch: any;
  public nameEmailCustomerNum: string = $localize`:@@customerSearchComponent.placeholder.nameEmailCustomerNum:Name, Email, Customer number`;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private customerService: CustomerService,
    private storage: StorageService,
    public navigationService: NavigationService
  ) {
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
    this.customerService.castCustomerSearchResults.pipe(untilDestroyed(this))
      .subscribe(customers => this.customers = customers);
    this.recentSearch = this.customerService.lastSearch;
    this.navigationService.setCurrentPage('customerSearchBasic');
    this.storage.castCustomerSearchHistory.pipe(untilDestroyed(this))
      .subscribe(history => {
        if (history !== null) {
          if (history[this.selectedClub.id]) {
            this.searchHistory = history[this.selectedClub.id];
          } else {
            this.searchHistory = [];
          }
        } else {
          this.searchHistory = [];
        }
      });
  }

  public ngOnDestroy(): void { }

  /**
   * Creates animation and form on component init.
   */
  public ngOnInit(): any {
    this.createForm();
    this.customerService.castLastSearchUpdated.pipe(untilDestroyed(this))
      .subscribe(search => {
        if (search) {
          this.recentSearch = search;
          this.getSearchResultsAndFillData();
        }
      });
  }

  /**
   * Creates the form and applies the validators.
   */
  private createForm(): void {
    this.form = this.formBuilder.group({
      search: [null, [Validators.minLength(2)]]
    });
  }

  public searchCustomer(value: any, byEnter: boolean = false): void {
    if (value && this.form.valid) {
      this.customerService.setSearchQuery(value, 'basic', byEnter);
    }
  }

  /**
   * Retrieves the search results from the service, and fills all the form fields
   */
  public getSearchResultsAndFillData(): void {
    this.customerService.setCustomerSearchResults(null);
    if (this.recentSearch !== null && this.recentSearch.basic === true) {
      setTimeout(() => {
        this.form.controls.search.patchValue(this.recentSearch.values);
        this.searchCustomer(this.recentSearch.values);
        this.customerService.setLastSearchResults(null);
      }, 200);
    }
  }

}
